import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("gv_cart")) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem("gv_cart", JSON.stringify(items)); }, [items]);

  const addItem = (item) => setItems((prev) => [...prev, { ...item, _id: Date.now() + Math.random() }]);
  const removeItem = (id) => setItems((prev) => prev.filter((i) => i._id !== id));
  const updateItem = (id, patch) => setItems((prev) => prev.map((i) => (i._id === id ? { ...i, ...patch } : i)));
  const updateQty = (id, qty) => setItems((prev) => prev.map((i) => (i._id === id ? { ...i, quantity: Math.max(1, qty) } : i)));
  const clear = () => setItems([]);

  const count = items.reduce((n, i) => n + i.quantity, 0);
  const subtotal = items.reduce((n, i) => n + i.unit_price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateItem, updateQty, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
};
